import { useMemo } from 'react';

import { getPlanPrice } from '@services/products';

import { IFundingDetail } from '@app-types/funding';
import { MobilePlanType } from '@app-types/plan';
import { ProductChildFull } from '@app-types/product';

import { MarketingsState } from '@hooks/use-marketings';

import { getPricesDetails } from '@product-detail/helpers';

export function useProductPrice(
    currentProduct: ProductChildFull,
    currentPlan: MobilePlanType | null | undefined,
    selectedFunding: IFundingDetail | undefined,
    marketings: MarketingsState,
    simulatedPortabilitySelected: boolean,
) {
    const planPrice = useMemo(
        () => (currentPlan ? getPlanPrice(currentPlan, marketings, simulatedPortabilitySelected) : undefined),
        [marketings, currentPlan, simulatedPortabilitySelected],
    );

    const prices = useMemo(
        () => getPricesDetails(currentProduct, selectedFunding, planPrice),
        [currentProduct, selectedFunding, planPrice],
    );

    const noPlanPrice = useMemo(
        () => getPricesDetails(currentProduct).productPrices.marketingAmount,
        [currentProduct.gencode],
    );

    return {
        prices,
        noPlanPrice,
    };
}
